module.exports = __webpack_public_path__ + "media/taipei/clash_clan-ba4edb21.jpg";